<!-- 游戏配置 -->
<template>
  <div class='content'>
    <el-button size="small" type="primary" @click="title='新增游戏';resetForm();dialogVisible=true">新增游戏</el-button>

    <el-table 
      :data="tableData"
      class="mt-20"
      :header-cell-style="{'text-align':'center'}"
      :cell-style="{'text-align':'center'}">
      <!-- show-overflow-tooltip -->
      <el-table-column label="游戏名称" prop="gameName"></el-table-column>
      <el-table-column label="app_name" prop="appName"></el-table-column>
      <el-table-column label="登陆方式" prop="bindType">
        <template slot-scope="scope">{{ scope.row.bindType|bindTypeFilters }}</template>
      </el-table-column>
      <el-table-column label="gameID" prop="outGameId"></el-table-column>
      <el-table-column label="图片" prop="gameLogo">
        <template slot-scope="scope">
          <el-image 
            style="width: 50px; height: 50px"
            :src="scope.row.gameLogo|getImgUrl" 
            :preview-src-list="[cache.fetchOssPath() || 'https://img.91cdkey.com/'+scope.row.gameLogo]">
          </el-image>
        </template>
      </el-table-column>
      <el-table-column label="排序" prop="gameOrder"></el-table-column>
      <el-table-column label="状态" prop="gameStatus">
        <template slot-scope="scope">{{ scope.row.gameStatus == 1 ? '展示' : '隐藏' }}</template>
      </el-table-column>
      <el-table-column fixed="right" label="操作">
        <template slot-scope="scope">
          <el-button 
            type="text" 
            size="small" 
            @click="editGame(scope.row.gameId)">编辑</el-button>
          <el-button 
            type="text" 
            size="small" 
            @click="updateGameStatus(scope.row.gameId,scope.row.gameStatus,scope.row.gameStatus == 1 ? '隐藏' : '展示')">{{ scope.row.gameStatus == 1 ? '隐藏' : '展示' }}</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-row class="mt-15 mr-20 text-right" v-if="total > 0">
      <el-pagination 
        small layout="total,prev,pager, next,sizes,jumper" 
        :page-size="params.pageSize"
        :total="total" 
        :current-page.sync="params.pageNum" 
        :page-sizes="[10 ,20 , 30, 40, 50]"
        @size-change="handleSizeChange" 
        @current-change="handleCurrentChange">
      </el-pagination>
    </el-row>

    <!-- 新增/编辑游戏 -->
    <el-dialog :title="title" top="20px" :visible.sync="dialogVisible"> 
      <el-form :model="form" ref="form" :rules="rules" label-width="auto">
        <el-form-item label="游戏名称：" prop="gameName">
          <el-input type="text" v-model="form.gameName" placeholder="请输入商品名称"></el-input>
        </el-form-item>
        <el-form-item label="app_name：" prop="appName">
          <el-input type="text" v-model="form.appName" placeholder="请输入绑定游戏时的ID字符串"></el-input>
        </el-form-item>
        <el-form-item label="gameId：" prop="outGameId">
          <el-input type="text" v-model="form.outGameId" placeholder="请输入游戏ID"></el-input>
        </el-form-item>
        <el-form-item label="登陆方式：" prop="bindType">
          <el-radio-group v-model="form.bindType">
            <el-radio label="0">QQ+WX</el-radio>
            <el-radio label="1">QQ</el-radio>
            <el-radio label="2">WX</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="排序：" prop="gameOrder">
          <el-input type="text" v-model="form.gameOrder" placeholder="请输入排序"></el-input>
        </el-form-item>
        <el-form-item label="图片：" prop="gameLogo">
          <ImageUpload :url="form.gameLogo" @image-uploaded="form.gameLogo = $event" />
        </el-form-item>
      </el-form>
      <el-row class="text-right mt-20">
        <el-button @click="resetForm();title='';dialogVisible=false">取消</el-button>
        <el-button type="primary" :loading="buttonLoading" @click="confirm()">确定</el-button>
      </el-row>
    </el-dialog>
  </div>
</template>
 
<script>
  import VueUeditorWrap from 'vue-ueditor-wrap';
  export default {
    components:{VueUeditorWrap},
    data() {
      //这里存放数据
      return {
        params:{
          pageNum: 1,
          pageSize: 10
        },
        total: 0,
        tableData:[],
        title: '新增游戏',
        dialogVisible: false,
        form:{ 
          gameId: null,
          gameName: '',
          appName: '',
          outGameId: '',
          bindType: '',
          gameOrder: '',
          gameLogo: ''
        },
        rules:{
          gameName: [{ required: true, message: "请输入游戏名称", trigger: "blur" }],
          appName: [{ required: true, message: "请输入appName", trigger: "blur" }],
          outGameId: [{ required: true, message: "请输入游戏ID", trigger: "blur" }],
          bindType: [{ required: true, message: "请选择绑定类型", trigger: "blur" }],
          gameOrder: [{ required: true, message: "请输入排序", trigger: "blur" }],
          gameLogo: [{ required: true, message: "请上传游戏logo", trigger: "blur" }],
        },
        buttonLoading: false,
      };
    },
    filters:{
      bindTypeFilters(bindType){
        switch (bindType) {
          case 0:
            return 'qq+wx';
          case 1:
            return 'qq';
          case 2:
            return 'wx';
          default:
            break;
        }
      }
    },
    //方法集合
    methods: {
      /**获取列表数据 */
      getTableList(){
        this.ajax.fetch({
          url: this.apis.gamesManage.get,
          disableLoading: true,
          method: 'post',
          param: this.params,
          successFunc: res=>{
            this.total = res.total;
            this.tableData = res.result;
          },
          errorFunc: err=>{
            this.$message.error(err.info);
          }
        });
      },
      editGame(gameId){
        let data = this.tableData.filter(i => i.gameId == gameId)[0];
        this.form.gameId = data.gameId;
        this.form.gameName = data.gameName;
        this.form.appName = data.appName;
        this.form.outGameId = data.outGameId;
        this.form.bindType = String(data.bindType);
        this.form.gameOrder = data.gameOrder;
        this.form.gameLogo = data.gameLogo;
        this.title = '编辑商品';
        this.dialogVisible = true;
      },
      /**更新游戏状态 */
      updateGameStatus(gameId,gameStatus,text){
        this.$confirm(`确定${text}该项?`, `确认${text}`, {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          let obj = { gameId: gameId,gameStatus:gameStatus==1?0:1 };
          this.ajax.fetch({
            url: this.apis.gamesManage.updateGameStatus,
            disableLoading: true,
            method: 'post',
            param: obj,
            successFunc: res=>{
              this.$message({
                type: 'success',
                message: `${text}成功!`
              });
              this.getTableList();
            },
            errorFunc: err=>{
              console.log(err);
            }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: `已取消${text}`
          });          
        });
      },
      confirm(){
        this.$refs["form"].validate((valid) => {
          if (valid) {
            if (this.form.gameId == null) {
              this.ajax.fetch({
                url: this.apis.gamesManage.add,
                disableLoading: true,
                method: 'post',
                param: this.form,
                successFunc: res=>{
                  this.$message.success('新增成功!');
                  this.dialogVisible = false;
                  this.resetForm();
                  this.getTableList();
                },
                errorFunc: err=>{
                  this.$message.error(err.info);
                }
              });
            }else{
              this.ajax.fetch({
                url: this.apis.gamesManage.update,
                disableLoading: true,
                method: 'post',
                param: this.form,
                successFunc: res=>{
                  this.$message.success('编辑成功!');
                  this.dialogVisible = false;
                  this.resetForm();
                  this.getTableList();
                },
                errorFunc: err=>{
                  this.$message.error(err.info);
                }
              });
            }
          }
        });
      },
      resetForm(){
        this.form={ 
          gameId: null,
          gameName: '',
          appName: '',
          outGameId: '',
          bindType: '',
          gameOrder: '',
          gameLogo: ''
        }
      },
      handleSizeChange(page) {
        this.params.pageSize = page;
        this.getTableList();
      },
      handleCurrentChange(val){
        this.params.pageNum = val;
        this.getTableList();
      },
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
      this.getTableList();
    },
  }
</script>

<style lang='scss' scoped>

</style>


// WEBPACK FOOTER //
// src/page/productsManage/gameList/gameList.vue